import React, {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import Link from '@mui/material/Link';

const UnionFormLogic = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        local: '',
        role: '',
        email: '',
        subject: '',
    });

    const [error, setError] = useState('Please fill out all fields');
    //const [change, setChange] = useState(null);
    const [result, setResult] = useState(null);

    const [submitSuccessful, setSubmitSuccessful] = useState(false);


    useEffect(() => {
        validateFields();
    }, [formData]);


    const handleChange = (e) => {
        /*if (validateFields()) {
          setChange(true);
        }*/
        // console.log("handle change called")

        const {name, value} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

    };

    const validateNotEmpty = (text) => {
        const textRegex = /^.+$/;
        return textRegex.test(text);
    };

    const validateEmail = (email) => {
        // Simple email validation using a regular expression
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateFields = () => {
        // console.log('validateFields called');
        if (!validateNotEmpty(formData.name) || !validateNotEmpty(formData.role) || !validateNotEmpty(formData.local)) {
            setError('Please fill out all fields');
            // console.log(!validateNotEmpty(formData.name) , !validateNotEmpty(formData.role) , !validateNotEmpty(formData.local))
            return false;
        }
        if (!validateEmail(formData.email)) {
            setError('Please enter a valid email address');
            return false;
        }
        setError('');
        return true;
    }

    const handleSubmit = (setSubmitInProgress) => {
        //e.preventDefault();
        //setChange(false);
        if (!validateFields()) {
            return false;
        }
        setSubmitInProgress(true);
        const apiUrl = 'https://tmfhnloi22ub2rc6lkvnm2ngpy0auzst.lambda-url.us-east-1.on.aws/';
        //const apiUrl = 'https://httpstat.us/500';
        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.text();
            })
            .then(data => {
                console.log('Server response:', data);
                // setResult('Thank You.  Your message has been recorded.');
                setSubmitSuccessful(true)
            })
            .catch(error => {
                console.error('Error:', error);
                setError('An Error has occurred.  Please try again later or contact us using a different method.');
            }).finally(() => setSubmitInProgress(false));
    };

    return {formData, handleChange, handleSubmit, error, result, submitSuccessful};
};

const UnionForm = () => {
    const {formData, handleChange, handleSubmit, error, result, submitSuccessful} = UnionFormLogic();
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [submitInProgress, setSubmitInProgress] = useState(false);


    const handleButtonClick = () => {
        setIsSubmitDisabled(true);
        handleSubmit(setSubmitInProgress);
    };

    useEffect(() => {
        //console.log('data changed');
        setIsSubmitDisabled(error.length > 0);
    }, [error]);

    formData.subject = "union_contact_form";
    return (
        <form onSubmit={handleSubmit}>
            <label>
                Name:
                <input type="text" name="name" className="full-width" value={formData.name} onChange={handleChange}/>
            </label>
            <label>
                Email:
                <input type="text" name="email" className="full-width" value={formData.email} onChange={handleChange}/>
            </label>
            <label>
                Phone Number (Optional):
                <input type="text" name="phone" className="full-width"
                       value={formData.phone}
                       onChange={handleChange}/>
            </label>
            <label>
                Local:
                <input type="text" name="local" className="full-width" value={formData.local} onChange={handleChange}/>
            </label>
            <label>
                Role/Position:
                <input type="text" name="role" className="full-width" value={formData.role} onChange={handleChange}/>
            </label>
            <button type="button" onClick={handleButtonClick} disabled={isSubmitDisabled}>Submit</button>
            <div className="classes-table">{error && <p style={{color: 'red'}}>{error}</p>}
                {(!error || result) && <p>{result}</p>}
                {submitInProgress &&
                    <Box className="classes-table">
                        <CircularProgress className="classes-table"/>
                    </Box>
                }
            </div>
            {submitSuccessful && <>
                <div><p><Link href="https://www.youtube.com/watch?v=2MSUhG11Wtg">Click Here to watch on YouTube</Link></p></div>
                <picture>
                <img className="img-responsive" src="/image/BearATACS.gif" alt="Bear aTACS demo gif"
                     style={{maxWidth: "100%", height: "auto", display: "block"}}/>
            </picture></>}
        </form>
    );
};

export default UnionForm;
